import React from "react";
import styles from "./style.module.css";

const Notification = () => {
  const NotificationData = [
    {
      id: 1,
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
      time: '10:10',
      image: require('../../assets/Clip path.png'),
    },
    {
      id: 2,
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
      time: '10:10',
      image: require('../../assets/Clip path.png'),
    },
    {
      id: 3,
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
      time: '10:10',
      image: require('../../assets/Clip path.png'),
    },
    {
      id: 4,
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
      time: '10:10',
      image: require('../../assets/Clip path.png'),
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <h1>Notifications</h1>
      <div className="container-fluid">
        <div className="row">
        <div className={styles.mainDiv} style={{display:'flex',background:'#8CC9E9', gap:'80%',height:'60px', alignItems:'center'}}>
              <h5 style={{marginLeft:'4.5%'}}>Today</h5>
              <h5>Mark as read</h5>
              </div>
          {NotificationData.map((notification) => (
            <>
            <div className="" style={{display:'flex', alignItems: 'center', marginLeft: '4%', marginRight: '10%', marginTop: '3%', marginBottom: '1%' }}>
              <img src={notification.image} className="" alt="Notification Image" />
              <p className="" style={{ marginLeft: '2%' }}>{notification.text}</p>
              <p className="" style={{ marginLeft: '21.7%' }}>{`${notification.time}`}</p>
            </div><hr style={{ border: '1px solid #999999' }} />
            </>
          ))}
        </div>
        <div style={{display:'flex',alignItems:'center', marginTop:'2%'}}>
              <h5 style={{marginLeft:'4.5%'}}>Yesterday</h5>
              </div>
              {NotificationData.map((notification) => (
            <div className="col" key={notification.id}>
              <div className="" style={{display:'flex', alignItems:'center', marginLeft:'4%', marginRight:'5%', marginTop:'1.1%', marginBottom:'1%'}}>
                <img src={notification.image} className="" alt="Notification Image" />
                  <p className="" style={{marginLeft:'2%'}}>{notification.text}</p>
                  <p className="" style={{marginLeft:'25.5%'}}>{`${notification.time}`}</p>
                </div>
                <hr style={{border:'1px solid #999999'}}/>
              </div>
          ))}
      </div>
    </div>
  );
};

export default Notification;
